import React from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import ComponentModal from "../../UI/Modal/ComponentModal";
import * as AuthenticationActions from "../../../middleware/Store/Actions/AuthenticationActions";
import * as LogoutUtils from "../../Utils/LogoutUtils";

import { faExclamation } from "@fortawesome/free-solid-svg-icons";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "LOGOUT";

const Logout = (props) => {
    const intl = useIntl();
    const history = useHistory();

    const handleLogout = () => {
        LogService.info(LOG_TAG, "handleLogout");
        props.logout()
            .finally(() => {
                history.push(LogoutUtils.ROOT_PATH);
            });
    }

    const handleClose = () => {
        LogService.info(LOG_TAG, "handleClose");
        history.goBack();
    }

    LogService.info(LOG_TAG, "render");
    return (
        <ComponentModal
            id="logoutModal"
            icon={faExclamation}
            title={intl.messages.logoutModalTitle}
            showFirstButton={true}
            showSecondButton={true}
            firstButtonLabel={intl.messages.logoutButton}
            onClick={() => handleLogout()}
            onSecondButtonClick={() => handleClose()}
            onClose={() => handleClose()}
            showModalOnInit={true}
        >
            <div className="mb-2 text-center">
                {intl.messages.logoutModalMessage}
            </div>
        </ComponentModal>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        logout: () => dispatch(AuthenticationActions.logout())
    }
}

export default connect(null, mapDispatchToProps)(Logout);